var map = {
	"./accessories/469901535_122116530170594007_7507984290815712315_n.jpg": 1680,
	"./accessories/480981757_1781557749086663_8212250243335532590_n.jpg": 7298,
	"./accessories/481221981_968145758784485_962729876009543906_n.jpg": 2885,
	"./accessories/482252520_692187939905561_7576180571036218528_n.jpg": 518,
	"./accessories/484050141_1790294191546352_7980360344163273714_n.jpg": 9233,
	"./accessories/484263229_1790293951546376_3727834074611820884_n.jpg": 2432,
	"./accessories/484339952_1790297384879366_4299107560674868936_n.jpg": 2756,
	"./accessories/484814661_1790293958213042_4273322495435193420_n.jpg": 7177,
	"./clip-in/01.jpg": 5726,
	"./clip-in/1.jpg": 4582,
	"./clip-in/4243da85a306cdb2f4a2b9c57b8f220d.jpg": 6532,
	"./clip-in/7c273f94584754c87bf520a137777332.jpg": 2671,
	"./clip-in/8c97a65e4cec82632ed94ebe5843cf93.jpg": 8288,
	"./clip-in/93eaf188a776476910a74e43b12ff750.jpg": 5509,
	"./clip-in/bc1f96e2b51214f1805cb4b381b951d3.jpg": 7365,
	"./clip-in/c0bf23ba8a3f3f14f49c1a722130f3e5.jpg": 1964,
	"./clip-in/z2.jpg": 615,
	"./clip-in/z3.jpg": 8682,
	"./hair-pieces/1.png": 9780,
	"./hair-pieces/2.png": 1407,
	"./hair-pieces/3.png": 7606,
	"./hair-pieces/4.png": 7577,
	"./hair-pieces/6.png": 4587,
	"./hair-pieces/7.png": 3042,
	"./hair-weft/IMG_3858.jpg": 9166,
	"./hair-weft/IMG_3865.jpg": 8410,
	"./hair-weft/IMG_3868.jpg": 5635,
	"./hair-weft/IMG_8251.jpg": 1248,
	"./hair-weft/IMG_8254.jpg": 2145,
	"./hair-weft/IMG_8264.jpg": 760,
	"./hair-weft/IMG_9541.jpg": 159,
	"./hair-weft/IMG_9542.jpg": 6544,
	"./hair-weft/IMG_9543.jpg": 5773,
	"./one-piece/IMG_3753.jpg": 2624,
	"./one-piece/IMG_3770.jpg": 6641,
	"./one-piece/IMG_3777.jpg": 4802,
	"./one-piece/IMG_8171.jpg": 7491,
	"./one-piece/IMG_8182.jpg": 8805,
	"./one-piece/IMG_8186.jpg": 8041,
	"./one-piece/IMG_9201.jpg": 6494,
	"./one-piece/IMG_9515.jpg": 1030,
	"./pre-bonded/1.jpg": 6982,
	"./pre-bonded/10.jpg": 7500,
	"./pre-bonded/11.jpg": 9113,
	"./pre-bonded/12.jpg": 3166,
	"./pre-bonded/13.jpg": 4475,
	"./pre-bonded/14.jpg": 2888,
	"./pre-bonded/15.jpg": 501,
	"./pre-bonded/4.jpg": 4223,
	"./pre-bonded/5.jpg": 1842,
	"./pre-bonded/6.jpg": 1741,
	"./pre-bonded/7.jpg": 608,
	"./pre-bonded/8.jpg": 5307,
	"./pre-bonded/9.jpg": 7470,
	"./tape-in/1.jpg": 8880,
	"./tape-in/2.jpg": 9199,
	"./tape-in/3.jpg": 2818,
	"./tape-in/4.jpg": 6417,
	"./tape-in/5.jpg": 6468,
	"./tape-in/6.jpg": 9043,
	"./tape-in/7.jpg": 4278,
	"./tape-in/8.jpg": 3269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4707;